<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <div v-if="deductionsPlansData">
      <DeductionsPlansTable
        :deductionsPlansData="deductionsPlansData"
        :deductionsPlanData="deductionsPlanData"
        v-on:setDeductionsPlanData="deductionsPlanData.fillData($event)"
      />

      <Pagination
        v-if="!isLoading"
        :paginationData="paginationData"
        v-on:changePage="changePage"
      />
      <DeductionsPlanDelete
        :deductionsPlanData="deductionsPlanData"
        v-on:refresh="getDeductionsPlanses()"
      />
    </div>

    <DeductionsPlanFloatBtns :textSearch="textSearch" v-on:search="search" />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DeductionsPlansTable from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlansTable.vue";
import DeductionsPlanDelete from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlanDelete.vue";
import DeductionsPlanFloatBtns from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlanFloatBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import DeductionsPlan from "@/models/settings/settingsSalary/deductionsPlans/DeductionsPlan";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "DeductionsPlans",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    DeductionsPlansTable,
    DeductionsPlanDelete,
    DeductionsPlanFloatBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      textSearch: "",
      paginationData: {
        totalPages: 1,
        totalItems: 0,
        countItemsInPage: 0,
        selfPage: 1,
      },
      deductionsPlansData: null,
      deductionsPlanData: new DeductionsPlan(),
    };
  },
  methods: {
    changePage(page) {
      this.paginationData.selfPage = page;
      this.getDeductionsPlanses();
    },
    search(text) {
      this.textSearch = text;
      this.getDeductionsPlanses();
    },
    async getDeductionsPlanses() {
      this.isLoading = true;
      try {
        const response = await this.deductionsPlanData.getDeductionsPlanses(
          this.language,
          this.userAuthorizeToken,
          this.selfPage,
          this.textSearch
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.paginationData = {
            totalPages: response.data.deductionsPlansPagination.totalPages,
            totalItems: response.data.deductionsPlansPagination.totalItems,
            countItemsInPage:
              response.data.deductionsPlansPagination.countItemsInPage,
            selfPage: response.data.deductionsPlansPagination.selfPage,
          };
          this.deductionsPlansData =
            response.data.deductionsPlansPagination.deductionsPlansData;
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.deductionsPlansData = null;
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.deductionsPlansData = null;
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.deductionsPlansData = null;
          this.exceptionMsg = response.data.msg;
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.deductionsPlansData = null;
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getDeductionsPlanses();
  },
};
</script>
